import { render, staticRenderFns } from "./SpinnerComp.vue?vue&type=template&id=3b9a8246&"
import script from "./SpinnerComp.vue?vue&type=script&lang=js&"
export * from "./SpinnerComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports